<template>
    <div ref="stickyModal" id="stickyModal" v-show="show"
        :style="{ width: width + 'px', height: height + 'px', top: top + 'px', left: left + 'px' }">
        <div class="stickyModalTool title">
            <img class="closeBtn" src="../assets/other_tools/web_link/btn_x.png" v-show="false"
                v-on:click="stickyShow(false)" />
        </div>
        <div ref="titleModal" id="titleModal" @pointerdown="startDrag($event, $refs.stickyModal, stickyMargin)">
            <input res="textTitle" id="textTitle" v-model="textTitle" type="text" placeholder="便利貼"
                @input="checkTitleLength" />
            <p class="stick-prompt" v-show="showTitlePrompt">{{ titlePrompt }}</p>
        </div>
        <div class="stickyModalTextArea">
            <div id="sticky-app" >
                <ckeditor ref="stickerEditor" :editor="editor" v-model="editorData" :config="editorConfig"
                    tag-name="textarea" @ready="onReadyEditor"> </ckeditor>
            </div>
        </div>
        <div id="buttonsModal" class="stickyModalTool buttons">
            <div v-on:click.stop="delStickyObj">
                <img res="stickyDelete" class="stickyModalToolButton" src="../assets/other_tools/common/delete.svg" />
                <span>刪除</span>
            </div>
            <div v-on:click.stop="saveSticky">
                <img res="stickySave" class="stickyModalToolButton" src="../assets/other_tools/common/confirm.svg" />
                <span>確認</span>
            </div>
        </div>
        <div id="zoomFrame">
            <img ref="zoomBtn" src="../assets/other_tools/common/zoomBtn.svg" draggable="false"
                v-on:pointerdown.stop="zoomMouseDown" />
        </div>
    </div>
    <ConfirmDialog ref="confirmDialog" />
</template>

<script>
import Editor from "../../ckeditor5/build/ckeditor";
import ConfirmDialog from "../components/dialogs/ConfirmDialog.vue";
import DragElem from "./DragElem.vue";
import { EVENT_TYPE } from "../js/event/event";
import { store } from "../store";
import { windowContentScaleX, windowContentScaleY } from "../js/common/content_scale";
import { DEBOUNCE } from '../js/common/debounce';
import { CHECK_INPUT_CHAR } from '../js/common/check_char';

export default {
    components: { ConfirmDialog },
    name: "app",
    data() {
        return {
            show: false,
            textTitle: "",
            cuStickyObj: null,

            mouseX: null,
            mouseY: null,

            curZoomWidth: 0,
            curZoomHeight: 0,

            showTitlePrompt: false,
            titlePrompt: "限10字元",
            checkTitleLength: null,

            //=========== ckeditor5 ======================
            editor: Editor,
            editorData: "便利貼",
            editorConfig: {
                // The configuration of the editor.
                placeholder: "請輸入內容",
            },
            width: 800,
            height: 600,
            minWidth: 400,
            minHeight: 300,

            currentStickyTool: null
        };
    },
    methods: {
        onReadyEditor(editor){
            editor.editing.view.domRoots.get("main").addEventListener("click",()=>{
                editor.editing.view.focus();
            })
        },
        stickyShow(visible) {
            this.show = visible;
            this.showTitlePrompt = false;
            if (visible == false) this.clearStickyModalData();

            this.top = store.pageHeight * 0.5 - 300;
            this.left = store.pageWidth * 0.5 - 400;
        },
        updateStickyData(stickyObj, txtTitle, txtMessageData, stickyTool) {
            this.cuStickyObj = stickyObj;
            this.textTitle = txtTitle;
            this.editorData = txtMessageData;
            this.currentStickyTool = stickyTool;
        },
        saveSticky() {
            if (this.cuStickyObj == null) return;

            this.currentStickyTool.updateCurrentSticky(this.textTitle, this.editorData);

            this.stickyShow(false);
        },
        delStickyObj() {
            this.$refs.confirmDialog.showDialog(
                "警告",
                "確定要刪除嗎？",
                () => {
                    if (this.cuStickyObj == null) return;
                    this.currentStickyTool.deleteCurrentSticky();
                    this.stickyShow(false);
                },
                () => { },
                "刪除"
            );
        },
        clearStickyModalData() {
            this.cuStickyObj = null;
            this.textTitle = "";
            this.editorData = "";
        },
        zoomMouseDown(e) {
            this.pointerType = e.pointerType;
            this.mouseX = e.clientX / windowContentScaleX.value;
            this.mouseY = e.clientY / windowContentScaleY.value;

            //const stickyBoundingRect = this.$refs.stickyModal.getBoundingClientRect();

            this.curZoomWidth = this.$refs.stickyModal.offsetWidth;
            this.curZoomHeight = this.$refs.stickyModal.offsetHeight;

            document.addEventListener(EVENT_TYPE.get(this.pointerType + ":move"), this.zoomMouseMove);
            document.addEventListener(EVENT_TYPE.get(this.pointerType + ":up"), this.zoomMouseUp);
        },
        zoomMouseMove(e) {
            let deltaX, deltaY;
            if (e.type === "mousemove" || e.type === "pointermove") {
                deltaX = e.clientX / windowContentScaleX.value - this.mouseX;
                deltaY = e.clientY / windowContentScaleY.value - this.mouseY;
            } else {
                deltaX = e.touches[0].screenX / windowContentScaleX.value - this.mouseX;
                deltaY = e.touches[0].screenY / windowContentScaleY.value - this.mouseY;
            }

            const ROOT = document.documentElement;
            let predictWidth = this.curZoomWidth + deltaX;
            let predictHeight = this.curZoomHeight + deltaY;

            predictWidth = Math.max(predictWidth, this.minWidth);
            predictHeight = Math.max(predictHeight, this.minHeight);

            if (predictHeight + this.top + this.$refs.zoomBtn.offsetHeight / 2 + 5 > store.baseSize.height - store.toolbarHeight) {
                predictHeight = store.baseSize.height - store.toolbarHeight - this.top - this.$refs.zoomBtn.offsetHeight / 2 - 5;
            }

            if (predictWidth + this.left + this.$refs.zoomBtn.offsetWidth / 2 + 5 > store.baseSize.width - store.toolbarWidth) {
                predictWidth = store.baseSize.width - store.toolbarWidth - this.left - this.$refs.zoomBtn.offsetWidth / 2 - 5;
            }

            this.width = predictWidth;
            this.height = predictHeight;

            ROOT.style.setProperty("--zoom-control-height", `${this.height - 168}px`);
        },
        zoomMouseUp(e) {
            document.removeEventListener(EVENT_TYPE.get(this.pointerType + ":move"), this.zoomMouseMove);
            document.removeEventListener(EVENT_TYPE.get(this.pointerType + ":up"), this.zoomMouseUp);
        },
        moveMouseDownWindow(e) {
            let elementSelected = this.$refs.stickyModal;
            this.mouseX = e.clientX - parseInt(getComputedStyle(elementSelected).left);
            this.mouseY = e.clientY - parseInt(getComputedStyle(elementSelected).top);
            document.addEventListener("mousemove", this.moveMouseMoveWindow);
            document.addEventListener("mouseup", this.moveMouseUpWindow);
        },
        moveMouseMoveWindow(e) {
            let elementSelected = this.$refs.stickyModal;
            elementSelected.style.left = e.clientX - this.mouseX + "px";
            elementSelected.style.top = e.clientY - this.mouseY + "px";
        },
        moveMouseUpWindow(e) {
            document.removeEventListener("mousemove", this.moveMouseMoveWindow);
            document.removeEventListener("mouseup", this.moveMouseUpWindow);
            this.mouseX = null;
            this.mouseY = null;
        },
    },
    mounted: function () {
        const self = this;
        

        document.documentElement.style.setProperty("--zoom-control-height", `${this.height - 168}px`);
        this.checkTitleLength = DEBOUNCE(() => {
            const result = CHECK_INPUT_CHAR(self.textTitle, 10);
            self.textTitle = result.substringStr;
            self.showTitlePrompt = !result.pass;
        }, 0);
    },
    mixins: [DragElem],
    computed: {
        stickyMargin() {
            return {
                top: 0,
                left: 0,
                right: -this.$refs.zoomBtn.offsetWidth / 2,
                bottom: -this.$refs.zoomBtn.offsetHeight / 2,
            };
        },
        stickTextStyle() {
            return { height: Math.max((this.height - 130), 190) + 'px' }
        }
    },
};
</script>

<style>
:root {
    --zoom-control-width: 0px;
    --zoom-control-height: 0px;
}

#stickyModal {
    position: absolute;
    top: calc(50% - 300px);
    left: calc(50% - 400px);
    background-color: rgb(0, 102, 203);

    min-width: 20em;
    min-height: 20em;
    border: 0.3em solid rgb(0, 102, 203);
    border-radius: 0.5rem;
    z-index: var(--z-index-sticky);
}

.stickyModalTextArea {
    min-width: 20em;
}

.ck.ck-reset.ck-list {
    width: 6.5em;
    max-width: 6.5em;
    min-width: 4.5em;
}

.ck.ck-reset.ck-list::-webkit-scrollbar {
    width: 20px;
}

.ck.ck-reset.ck-list::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background: #ffffff;
    /* border-radius: 10px; */
}

.ck.ck-reset.ck-list::-webkit-scrollbar-thumb {
    /* border-radius: 10px; */
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
    background: #808080;
}

.ck.ck-list__item {
    min-width: 1em !important;
}

.ck.ck-button.ck-color-table__remove-color.ck-off.ck-button_with-text {
    display: none;
}

#textTitle {
    top: 0em;
    font-size: 1.5em;
    text-align: center;
    border: 0.01em solid rgb(0, 102, 203);
    border-radius: 0.5rem;
    grid-column-start: 2;
    height: 1.5em;
}

.stick-prompt {
    color: red;
    font-weight: bold;
    font-size: 1.5rem;
    text-align: left;
    line-height: 0px;
    padding-left: 16px
}

.ck-editor__editable_inline {
    /* height: calc(27em + var(--zoom-control-height)) !important; */
    /* height: var(--zoom-control-height) !important;
  min-height: 9.5em; */
}

.ck-content {
    /* height: calc(27em + var(--zoom-control-height)) !important; */
    height: var(--zoom-control-height) !important;
    min-height: 9.5em;
}

.ck-list {
    height: 27em !important;
    overflow-y: auto !important;
}

.ck.ck-button__label {
    font-size: 1em !important;
}

#stickyModal .title {
    margin-top: -1.5em;
}

#stickyModal .title img {
    float: right;
    width: 2.5em;
    margin-right: -1.5em;
}

#stickyModal .text-editor {
    background-color: #3db39d;
}

.stickyModalTool {
    height: 4em;
}

.stickyModalTool.title {
    display: none;
}

#stickyModal .buttons {
    position: relative;
    bottom: -0.05em;
    left: -0.05em;
    width: 100%;
    height: 10.4%;

    background-color: #ffffff;
    border: 0.01em solid rgb(0, 102, 203);
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;

    display: flex;
    justify-content: space-around;
}

.text-editor {
    display: flex;
    justify-content: space-around;
}

.stickyModalToolButton {
    position: relative;
    top: 0.6em;
    background-color: #ffffff;
}

#titleModal {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-content: center;
    align-items: center;

    height: 4em;
    max-height: 4em;
    min-height: 4em;
}

#buttonsModal {
    max-height: 3.9em;
    min-height: 3.9em;
}

#buttonsModal span {
    position: relative;
    top: 0em;
    font-size: 1.6em;
}

#zoomFrame>img {
    float: right;
    position: relative;
    top: -20px;
    left: 20px;
}

.ck.ck-editor__main {
    min-height: 9.5em;
}

#sticky-app {
    background-color: white;
}

::selection {
    background-color: skyblue;
}

.ck-content p {
    font-size: 24px;
}

</style>